import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

const SECTIONS = [
  {
    n: "01",
    title: "Verantwortlicher",
    body: (
      <>
        <p>
          Verantwortlich für die Datenverarbeitung auf dieser Website im Sinne der
          Datenschutz-Grundverordnung (DSGVO) ist:
        </p>
        <p className="mt-3 text-white">
          PINE Gaming GmbH
          <br />
          Lehfeld 1
          <br />
          21029 Hamburg
          <br />
          Deutschland
        </p>
        <p className="mt-3">
          Telefon: 0151 22202892
          <br />
          E-Mail: kontakt@pinegaming.de
        </p>
      </>
    ),
  },
  {
    n: "02",
    title: "Zwecke der Datenverarbeitung",
    body: (
      <>
        <p>Wir verarbeiten personenbezogene Daten ausschließlich, um:</p>
        <ul className="list-disc pl-5 mt-3 space-y-1">
          <li>Ihre Kontaktanfragen und Standortprüfungen zu bearbeiten,</li>
          <li>Ihnen unsere Leistungen (z.B. Erstgespräch, Produktfit-Analyse) anzubieten,</li>
          <li>diese Website technisch bereitzustellen und sicher zu betreiben.</li>
        </ul>
      </>
    ),
  },
  {
    n: "03",
    title: "Welche Daten wir erheben",
    body: (
      <>
        <p>Bei Nutzung unserer Formulare erheben wir die von Ihnen freiwillig gemachten Angaben:</p>
        <ul className="list-disc pl-5 mt-3 space-y-1">
          <li>Stammdaten (Vorname, Nachname, Unternehmen, Rolle)</li>
          <li>Kontaktdaten (E-Mail, Telefon, optional Website)</li>
          <li>
            Standort-/Projektdaten (Ort, verfügbare Fläche, Raumhöhe, aktueller Zustand, Zielgruppe,
            Zeitplan, Nachricht)
          </li>
          <li>Optional hochgeladene Dateien (Grundrisse, Fotos)</li>
          <li>
            Technische Daten (IP-Adresse, Browser, Zeitpunkt) – ausschließlich für Sicherheit und
            Missbrauchsprävention
          </li>
        </ul>
      </>
    ),
  },
  {
    n: "04",
    title: "Rechtsgrundlagen",
    body: (
      <>
        <p>Die Verarbeitung erfolgt auf folgenden Rechtsgrundlagen:</p>
        <ul className="list-disc pl-5 mt-3 space-y-1">
          <li>
            Art. 6 Abs. 1 lit. b DSGVO – zur Anbahnung und Erfüllung eines Vertrags oder
            vorvertraglicher Maßnahmen,
          </li>
          <li>Art. 6 Abs. 1 lit. a DSGVO – Einwilligung (Datenschutz-Checkbox im Formular),</li>
          <li>
            Art. 6 Abs. 1 lit. f DSGVO – berechtigtes Interesse am sicheren Betrieb der Website.
          </li>
        </ul>
      </>
    ),
  },
  {
    n: "05",
    title: "Speicherdauer",
    body: (
      <>
        <p>
          Wir speichern Ihre Anfragedaten so lange, wie es für die Bearbeitung Ihrer Anfrage
          erforderlich ist, sowie darüber hinaus im Rahmen gesetzlicher Aufbewahrungspflichten.
          Nach Wegfall des Zwecks und nach Ablauf gesetzlicher Fristen werden Ihre Daten gelöscht.
        </p>
      </>
    ),
  },
  {
    n: "06",
    title: "Weitergabe an Dritte",
    body: (
      <>
        <p>
          Eine Weitergabe Ihrer Daten an Dritte erfolgt nicht, außer an sorgfältig ausgewählte
          Auftragsverarbeiter (z.B. Hosting, Object-Storage), die strikt nach unseren Weisungen
          und gemäß Art. 28 DSGVO tätig werden. Hochgeladene Dateien werden in einem
          europäischen oder DSGVO-konformen Storage-Dienst abgelegt.
        </p>
      </>
    ),
  },
  {
    n: "07",
    title: "Ihre Rechte",
    body: (
      <>
        <p>Sie haben jederzeit das Recht auf:</p>
        <ul className="list-disc pl-5 mt-3 space-y-1">
          <li>Auskunft (Art. 15 DSGVO),</li>
          <li>Berichtigung (Art. 16 DSGVO),</li>
          <li>Löschung (Art. 17 DSGVO),</li>
          <li>Einschränkung der Verarbeitung (Art. 18 DSGVO),</li>
          <li>Datenübertragbarkeit (Art. 20 DSGVO),</li>
          <li>Widerspruch (Art. 21 DSGVO),</li>
          <li>Widerruf erteilter Einwilligungen (Art. 7 Abs. 3 DSGVO),</li>
          <li>Beschwerde bei einer Datenschutz-Aufsichtsbehörde (Art. 77 DSGVO).</li>
        </ul>
        <p className="mt-3">
          Bitte richten Sie Ihre Anfrage formlos an{" "}
          <a href="mailto:kontakt@pinegaming.de" className="text-[#18E096] hover:text-white">
            kontakt@pinegaming.de
          </a>
          .
        </p>
      </>
    ),
  },
  {
    n: "08",
    title: "Cookies & Reichweitenmessung",
    body: (
      <>
        <p>
          Diese Website setzt technisch notwendige Cookies und nutzt Reichweitenanalyse, um die
          Funktionalität und Performance der Seite sicherzustellen. Es werden keine Daten zu
          Werbezwecken an Dritte weitergegeben.
        </p>
      </>
    ),
  },
  {
    n: "09",
    title: "Aktualität und Änderung",
    body: (
      <>
        <p>
          Diese Datenschutzerklärung ist aktuell gültig. Durch die Weiterentwicklung unserer
          Website kann es notwendig werden, diese Datenschutzerklärung zu ändern. Die jeweils
          aktuelle Datenschutzerklärung kann jederzeit auf dieser Seite abgerufen werden.
        </p>
      </>
    ),
  },
];

export default function Datenschutz() {
  return (
    <>
      <SEO
        title="Datenschutz – PINE Systems"
        description="Informationen zur Verarbeitung personenbezogener Daten auf der PINE Systems Website (DSGVO)."
        noindex
      />
      <section className="relative border-b border-[rgba(255,255,255,0.08)] overflow-hidden">
        <div className="absolute inset-0 grid-overlay opacity-30" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 pt-28 pb-12 md:pt-36 md:pb-20">
          <div className="overline">Rechtliches</div>
          <h1 className="font-display text-4xl md:text-6xl uppercase mt-4 max-w-4xl leading-[1.05]">
            <span className="text-[#18E096]">Datenschutz.</span>
          </h1>
          <p className="text-[#AEB7B7] mt-6 max-w-3xl">
            Wir gehen sorgfältig mit personenbezogenen Daten um. Diese Erklärung informiert Sie
            transparent darüber, welche Daten wir wann, warum und auf welcher Rechtsgrundlage
            verarbeiten.
          </p>
        </div>
      </section>

      <section>
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-20 space-y-6">
          {SECTIONS.map((s) => (
            <article
              key={s.n}
              className="surface p-8"
              data-testid={`datenschutz-${s.n}`}
            >
              <div className="overline mb-3">{s.n}</div>
              <h2 className="font-display text-xl md:text-2xl uppercase">{s.title}</h2>
              <div className="text-[#AEB7B7] mt-4 leading-relaxed text-sm md:text-base">
                {s.body}
              </div>
            </article>
          ))}

          <div className="text-center pt-6">
            <Link to="/" className="btn-secondary" data-testid="datenschutz-back">
              Zurück zur Startseite
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
